export const START_SCREEN_IMAGE_URL = `${process.env.NEXT_PUBLIC_STATIC_URL}/images/partnerStartScreen`;
export const START_SCREEN_ARRAY_LENGTH = 3;
export const DTD_ROLE = 'ROLE_DTD_USER';
export const COMMON_ROLE = 'ROLE_COMMON';
export const CLIENT_ROLE = 'ROLE_CLIENT_USER';
export const DMW_CLIENT_ROLE_USER = 'ROLE_DMW_CLIENT_USER';